module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ark-leaderboard', {
    staticClass: "ark-leaderboard",
    attrs: {
      "ark-test-id": "leaderboard-widget"
    }
  }, [_c('tabs', {
    attrs: {
      "tabs": _vm.config.tabs,
      "chosenPeriod": _vm.chosenPeriod
    },
    on: {
      "update:chosenPeriod": function($event) {
        _vm.chosenPeriod = $event
      }
    }
  }), _vm._v(" "), _c('ark-div', {
    staticClass: "ark-leaderboard__body"
  }, [(!_vm.leaderboardData) ? _c('ark-preload', {
    staticClass: "ark-leaderboard__loader"
  }) : _vm._e(), _vm._v(" "), (_vm.leaderboardData) ? _c('leaderboard-content', {
    attrs: {
      "leaderboardData": _vm.leaderboardData,
      "chosenPeriod": _vm.chosenPeriod,
      "emptyLeaderboardText": _vm.config.emptyLeaderboardText
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fb49a16","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainLeaderboard/MainLeaderboard.vue
// module id = 17
// module chunks = 0